<div class="container">
  <div class="logo b2a">
    <img class="image" src="/assets/logos/4C_Logo_B2A_Claim2018.svg" alt="Back2Action">
    <p class="subline" >{{'LOGIN.logosubline' |translate}}</p>
  </div>

  <app-module>
    <div class="signup-container">

      <div class="step-indicator">
        <div class="step-label" [ngClass]="{'active':currentStep == 1}">1</div>
        <div class="step-label" [ngClass]="{'active':currentStep == 2}">2</div>
        <div class="step-label" [ngClass]="{'active':currentStep == 3}">3</div>
      </div>

      <div class="step-container" [@stepChangeParent]>
        <div #step class="step" *ngIf="currentStep == 1" [@stepChange]="'first'">
          <form [formGroup]="registerForm" (ngSubmit)="submitRegisterForm($event)">
            <h1>{{'SIGNUP.STEP1.header' | translate}}</h1>
            <p class="intro">{{'SIGNUP.STEP1.subheader' | translate}}</p>

            <div class="input-row">
              <app-input [error]="registerForm.controls['email'].invalid && registerForm.controls['email'].touched">
                  {{'SIGNUP.STEP1.labelEmail' | translate}}
                <input [formControlName]="'email'" type="email" placeholder="{{'SIGNUP.STEP1.placeholderEmail' | translate}}">
                <div app-input-error *ngIf="registerForm.controls['email'].invalid && registerForm.controls['email'].touched">
                    {{ 'GENERAL.FORMS.requiredInvalid' | translate }}
                </div>
              </app-input>
            </div>

            <div class="input-row">
              <app-input [error]="registerForm.controls['password'].invalid && registerForm.controls['password'].touched">
                  {{'SIGNUP.STEP1.labelPassword' | translate}}
                <input [formControlName]="'password'" type="password" placeholder="{{'SIGNUP.STEP1.placeholderPassword' | translate}}">
                <div app-input-error *ngIf="registerForm.controls['password'].invalid && registerForm.controls['password'].touched">
                    {{ 'GENERAL.FORMS.passwordInvalid' | translate }}<br>
                    {{ 'GENERAL.FORMS.passwordRequirements' | translate }}
                </div>
              </app-input>
              <app-input [error]="registerForm.controls['confirmPassword'].invalid && registerForm.controls['confirmPassword'].touched">
                  {{'SIGNUP.STEP1.labelPasswordRepeat' | translate}}
                <input [formControlName]="'confirmPassword'" type="password" placeholder="{{'SIGNUP.STEP1.placeholderPassword' | translate}}">
                <div app-input-error *ngIf="registerForm.controls['confirmPassword'].invalid && registerForm.controls['confirmPassword'].touched">
                    {{ 'GENERAL.FORMS.passwordConfirmInvalid' | translate }}
                </div>
              </app-input>
            </div>

            <div class="error" *ngIf="signupError !== ''">{{'SIGNUP.ERROR.'+ signupError | translate}}</div>

            <div class="button-row">
              <button mat-raised-button color="accent" [disabled]="!registerForm.valid">{{'SIGNUP.STEP1.nextStepBtn' | translate}}</button>
            </div>
          </form>
        </div>

        <div #step class="step" *ngIf="currentStep == 2" [@stepChange]>
          <h1>{{'SIGNUP.STEP2.header' | translate}}</h1>
          <p class="intro text-center">{{'SIGNUP.STEP2.subheader' | translate}}</p>
          <p class="intro text-center">{{'SIGNUP.STEP2.mailHint' | translate}}</p>
          <div class="text-center">
            <button (click)="requestNewMail()" mat-raised-button>{{'SIGNUP.STEP2.resendBtn' | translate}}</button>
          </div>

          <div class="error" *ngIf="signupError !== ''">{{'SIGNUP.ERROR.'+ signupError | translate}}</div>
        </div>

        <div #step class="step" *ngIf="currentStep == 3" [@stepChange]="'first'">
          <h1>{{'SIGNUP.STEP3.header' | translate}}</h1>
          <form [formGroup]="profileForm" (ngSubmit)="submitProfileForm()">
            <div class="input-row">
              <app-input [type]="'info'">
                {{'SIGNUP.STEP3.labelCompany' | translate}}
                <div info>{{company.title}}</div>
              </app-input>

              <app-input [error]="profileForm.controls['branch'].invalid && profileForm.controls['branch'].touched" *ngIf="company.branchoffices && company.branchoffices.length > 0" >
                {{'SIGNUP.STEP3.labelBranch' | translate}}
                <select [formControlName]="'branch'">
                  <option value="" disabled> {{'SIGNUP.STEP3.placeholderBranch' | translate}}</option>
                  <option value="{{branch._id}}" *ngFor="let branch of company.branchoffices">{{branch.title}}</option>
                </select>
                <div app-input-error *ngIf="profileForm.controls['branch'].invalid && profileForm.controls['branch'].touched">
                  {{ 'GENERAL.FORMS.branchInvalid' | translate }}
                </div>
              </app-input>
            </div>

            <div class="input-row">
              <app-input>
                {{'SIGNUP.STEP3.labelTitle' | translate}}
                <select [formControlName]="'title'" name="" id="">
                  <option value="none" selected>{{'SIGNUP.STEP3.titleOptionNone' | translate}}</option>
                  <option value="male">{{'SIGNUP.STEP3.titleOptionMale' | translate}}</option>
                  <option value="female">{{'SIGNUP.STEP3.titleOptionFemale' | translate}}</option>
                </select>
              </app-input>
            </div>

            <app-input [error]="profileForm.controls['prename'].invalid && profileForm.controls['prename'].touched">
              {{'SIGNUP.STEP3.labelPrename' | translate}}
              <input [formControlName]="'prename'" type="text" placeholder="{{'SIGNUP.STEP3.placeholderPrename' | translate}}">
              <div app-input-error *ngIf="profileForm.controls['prename'].invalid && profileForm.controls['prename'].touched">
                  {{ 'GENERAL.FORMS.prenameInvalid' | translate }}
              </div>
            </app-input>

            <app-input [error]="profileForm.controls['surname'].invalid && profileForm.controls['surname'].touched">
              {{'SIGNUP.STEP3.labelSurname' | translate}}
              <input type="text" [formControlName]="'surname'" placeholder="{{'SIGNUP.STEP3.placeholderSurname' | translate}}">
              <div app-input-error *ngIf="profileForm.controls['surname'].invalid && profileForm.controls['surname'].touched">
                  {{ 'GENERAL.FORMS.surnameInvalid' | translate }}
              </div>
            </app-input>

            <app-input class="full-width" [type]="'checkbox'" [error]="profileForm.controls['acceptToS'].invalid && profileForm.controls['acceptToS'].touched">
              <span>
                {{'SIGNUP.STEP3.acceptPolicyText.part1' | translate}}
                <a routerLink="/tos">{{'NAVIGATION.navToS' | translate}}</a>
                {{'SIGNUP.STEP3.acceptPolicyText.part2' | translate}}
                <a routerLink="/privacy">{{'NAVIGATION.navPrivacy' | translate}}</a>
                {{'SIGNUP.STEP3.acceptPolicyText.part3' | translate}}
              </span>
              <input type="checkbox" [formControlName]="'acceptToS'" name="" id="">
              <div app-input-error *ngIf="profileForm.controls['acceptToS'].invalid && profileForm.controls['acceptToS'].touched">
                {{ 'GENERAL.FORMS.acceptToSInvalid' | translate }}
              </div>
            </app-input>

            <!--<app-input [type]="'checkbox'" [error]="profileForm.controls['acceptNewsletter'].invalid && profileForm.controls['acceptNewsletter'].touched">
              {{'SIGNUP.STEP3.acceptNewsletterText' | translate}}
              <input type="checkbox" [formControlName]="'acceptNewsletter'" name="" id="">
              <div app-input-error *ngIf="profileForm.controls['acceptNewsletter'].invalid && profileForm.controls['acceptNewsletter'].touched">
                  {{ 'GENERAL.FORMS.acceptNewsletterInvalid' | translate }}
              </div>
            </app-input>-->
            <div class="button-row">
              <button mat-raised-button color="accent" [disabled]="!profileForm.valid">{{'SIGNUP.STEP3.doneBtn' | translate}}</button>
            </div>
          </form>

        </div>
      </div>
    </div>
  </app-module>
</div>
<app-footer></app-footer>


// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/sign-up/sign-up.component.html